import React from 'react';
import { BrowserRouter, Switch, Route } from 'react-router-dom';
import './App.css';
import Header from './components/header/header.component';
import Footer from './components/footer/footer.component';
import WorldDashboard from './components/dashboard/world/worlddashboard.component';
import Homepage from './page/homepage/homepage.component';
import Details from './page/details/details.component';
import Error from './components/error/error.component';
import Loader from 'react-loader-spinner';
import ScrollToTop from './utils/scrollToTop';
import CountryDashboard from './components/dashboard/country/countrydashboard.component';
class App extends React.Component {
  render() {
    let app = (
      <div className="loader">
        <Loader
          type="Audio"
          color="#00BFFF"
          height={100}
          width={100}
        />
      </div>
    );

    return (
      <BrowserRouter>
        <ScrollToTop>
          <div className="App">
            <Header />
            <Switch>
              <Route exact path="/" render={(props) => (
                <WorldDashboard key={props.match.params.countrycode} {...props} />)
              } />

              <Route exact path="/details/:countrycode" render={(props) => (
                <WorldDashboard key={props.match.params.countrycode} {...props} />)
              } />
              <Route component={Error} />
            </Switch>
            <Footer />

          </div>
        </ScrollToTop>
      </BrowserRouter>
    );
  }
}

export default App;
//{//<Route exact path="/" component={WorldDashboard} />}